import React from 'react';
import DOMPurify from 'dompurify';

const SafeHtml = ({ html, className = '', style = {} }) => {
  // Sanitize HTML content to prevent XSS attacks
  const sanitizedHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'p', 'br', 'div', 'span', 'section', 'article', 'header', 'footer', 'main', 'aside',
      'a', 'img', 'strong', 'em', 'b', 'i', 'u', 'small', 'sub', 'sup',
      'ul', 'ol', 'li', 'dl', 'dt', 'dd',
      'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption',
      'blockquote', 'pre', 'code', 'hr',
      'form', 'input', 'button', 'label', 'select', 'option', 'textarea',
      'iframe', 'video', 'audio', 'source', 'track'
    ],
    ALLOWED_ATTR: [
      'href', 'title', 'target', 'rel',
      'src', 'alt', 'title', 'width', 'height', 'loading',
      'frameborder', 'allowfullscreen',
      'controls', 'autoplay', 'loop', 'muted',
      'type', 'kind', 'srclang', 'label',
      'name', 'placeholder', 'required', 'disabled', 'value', 'checked',
      'selected', 'rows', 'cols', 'action', 'method', 'enctype',
      'class', 'id', 'style', 'title', 'data-*'
    ],
    ALLOW_DATA_ATTR: true,
    FORBID_TAGS: ['script', 'object', 'embed', 'applet', 'form'],
    FORBID_ATTR: ['onload', 'onerror', 'onmouseover', 'onclick', 'onfocus', 'onblur'],
  });

  return (
    <div 
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default SafeHtml;